import { Button } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import PlanningUserSvg from '../../assets/icons/planning-user-grey.svg?react';

export const NoSprintInProgress = () => {
  const navigate = useNavigate();
  const { orgId } = useParams();
  const { spaceId } = useParams();

  return (
    <div className="flex flex-col items-center justify-center gap-5" style={{ height: 'calc(100vh - 80px)' }}>
      <div className="flex items-center justify-center w-12 h-12 bg-neutral-200 rounded-full">
        <PlanningUserSvg />
      </div>
      <div className="text-center text-neutral-900 text-sm font-medium leading-tight">
        No Sprint is currently in progress
      </div>
      <Button
        type="primary"
        className="text-white text-base font-semibold leading-tight"
        onClick={() => navigate(`/${orgId}/space/${spaceId}/planning`)}
      >
        Start Planning
      </Button>
    </div>
  );
};
